import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { px2rem } from '../utils/helpers/style.js';
import { spacing } from '../constants/spacing.js';

var sizingsNative = {
  s: {
    height: 48,
    content: {
      paddingTop: 8,
      paddingBottom: 14
    }
  },
  m: {
    height: 56,
    content: {
      paddingTop: 16,
      paddingBottom: 14
    }
  },
  l: {
    height: 64,
    content: {
      paddingTop: 32,
      paddingBottom: 14
    }
  }
};
var accordionThemeNative = {
  backgroundColor: colors.lightGrey,
  borderColor: colors.cloudGrey,
  fontColor: 'text',
  sizings: sizingsNative
};
var accordionDarkThemeNative = {
  backgroundColor: colors.mineShaftGrey,
  borderColor: colors.octoberGrey,
  fontColor: 'text',
  sizings: sizingsNative
};
var sizingsWeb = {
  s: {
    fontSize: px2rem(16),
    height: px2rem(48),
    content: {
      paddingVertical: spacing.xxs,
      paddingTop: spacing.xxxs
    }
  },
  m: {
    fontSize: px2rem(18),
    height: px2rem(56),
    content: {
      paddingVertical: spacing.xxs,
      paddingTop: spacing.xxs
    }
  },
  l: {
    fontSize: px2rem(18),
    height: px2rem(64),
    content: {
      paddingVertical: spacing.s,
      paddingTop: undefined
    }
  }
};
var accordionAttributesWeb = {
  /**
   * Background color of the button and the opened container element
   */
  backgroundColor: colors.lightGrey,
  borders: {
    active: 'primary',
    inactive: colors.cloudGrey,
    radius: 'borders.radius',
    style: 'full'
  },

  /**
   * Text and chevron color for plain accordion
   */
  plainColor: 'secondary',

  /**
   * Text and chevron color for normal accordion
   */
  fontColor: 'text',
  fontSize: px2rem(18),
  height: px2rem(64),
  content: {
    paddingVertical: spacing.s,
    paddingHorizontal: px2rem(14),
    paddingTop: undefined,
    borderless: {
      paddingHorizontal: px2rem(16)
    }
  },
  sizings: sizingsWeb
};
var accordionThemeWeb = _extends({}, accordionAttributesWeb, {
  variants: {
    condensed: {
      borders: {
        style: 'bottomOnly'
      }
    }
  }
});
var accordionDarkThemeWeb = _extends({}, accordionThemeWeb, {
  backgroundColor: colors.mineShaftGrey,
  borders: _extends({}, accordionThemeWeb.borders, {
    inactive: colors.inkGrey
  })
});

export { accordionDarkThemeNative, accordionDarkThemeWeb, accordionThemeNative, accordionThemeWeb };
